module.exports = __webpack_public_path__ + "assets/940dd295e7981a8fac0a74d79be11bc8.mp4";